// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"143":"app","998":"chunk-vendors"}[chunkId] + "." + {"143":"cd77503d","998":"618b2ab2"}[chunkId] + ".css";
};